var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilter, refresh: _vm.refreshAlerts },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.alerts.alert_configuration_add"),
              icon: "fa-light fa-plus",
              variant: "primary",
            },
            on: { click: _vm.actionAdd },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") +
                " " +
                _vm.$t("common.alerts.alert_configuration"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.applyFilters,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.listItemsAlerts.length > 0
                        ? _c("b-table", {
                            key: _vm.refreshKey,
                            staticClass: "table-striped",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              items: _vm.listItemsAlerts,
                              fields: _vm.fields,
                              hover: "",
                              selectable: _vm.listItemsAlerts.length > 0,
                              "empty-text": _vm.$t("common.security.no_result"),
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                              "row-selected": _vm.onRowClicked,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(MetricsKey)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getMetricsKeyTranslation(
                                            data.value
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(ThresholdHigh)",
                                fn: function (data) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.value))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(ThresholdLow)",
                                fn: function (data) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.value))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(ThresholdUnit)",
                                fn: function (data) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.value))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(UpdatedAt)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getDate(data.value))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(EmailGroupName)",
                                fn: function (data) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.value))]),
                                  ]
                                },
                              },
                              {
                                key: "cell(Criticality)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mapCriticalityToAlert(data.value)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(edit)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionEdit(
                                              $event,
                                              data.item.IdAlerts
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-pencil",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-3 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.actionDelete(
                                              $event,
                                              data.item.IdAlerts
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-regular fa-trash",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n                "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-5" },
              [
                _c(
                  "b-col",
                  [
                    _c("cm-pagination", {
                      attrs: {
                        maxResultsByPage: _vm.paginationObject.maxResults,
                        firstIndex: _vm.paginationObject.firstIndex,
                        nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                        refreshEvent: _vm.paginationObject.refresh,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }